import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Navbar from '../navbar/Navbar';
import "./digital.css";
import Formpage from '../Formpage/Formpage';
import AOS from 'aos';
import 'aos/dist/aos.css';


const items = [
  {
    title: 'Starter Plan',
    description: [
      'For Local/Small Businesses Getting Started Online',
      'SEO (5 Keywords)',
      '2 Social Media Platforms (8 Posts/Month)',
      '1 Basic Lead Generation Campaign (Meta/Google)',
      'Google Business Profile Optimization',
      'Monthly Report',
    ],
    img: 1,
  },
  {
    title: 'Growth Plan',
    description: [
      'For Brands Looking to Grow Visibility',
      'SEO (10–15 Keywords)',
      '3 Social Platforms (12 Posts + 4 Stories/Month)',
      'Basic Google Ads + Facebook Ads Setup (Budget Not Included)',
      'Landing Page Suggestion + Audit',
      'Monthly Analytics Report & Strategy Call',
    ],
    img: 2,
  },
  {
    title: 'Business Plan',
    description: [
      'For Established Brands & E-Commerce',
      'SEO (20+ Keywords with Monthly Optimization)',
      'Google Ads + Meta Ads Management (₹10K–₹25K Budget Suggested)',
      '20 Social Media Posts + 8 Stories/Month',
      '2 Reels or Video Ads/Month',
      'Email Marketing (2 Campaigns/Month)',
      'Conversion Tracking + Lead Analytics',
      'Bi-weekly Reporting & Consultation',
    ],
    img: 3,
  },
  {
    title: 'Corporate Plan',
    description: [
      'High-Impact Strategy for Bigger Brands',
      'Full SEO Strategy + On-Page, Off-Page, Technical',
      'Google & Meta Ads with Full Funnel Strategy',
      'LinkedIn Ads or B2B Marketing (if needed)',
      '30+ Posts (All Platforms) + 10 Stories + 4 Reels',
      'YouTube Marketing & Video Thumbnails',
      'WhatsApp & Email Automation Setup',
      'Weekly Reports + Dedicated Manager',
      'Competitor Monitoring + ROI Reports',
    ],
    img: 4,
  },
  {
    title: 'Add-On Services',
    description: [
      'Logo & Branding',
      'Landing Page Design',
      'WhatsApp Business API Setup',
      'CRM Setup/Integration',
      'E-commerce SEO',
      'Influencer Outreach',
    ],
    img: 5,
  },
];




function Digital() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });

    setTimeout(() => {
      AOS.refresh();
    }, 500);
  }, []);
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    centerMode: true,
    centerPadding: '0px',
    arrows: true,
    initialSlide: 0,

    responsive: [
      {
        breakpoint: 992, // tablet and below
        settings: {
          slidesToShow: 2,
          arrows: false,
          centerMode: false
        }
      },
      {
        breakpoint: 576, // mobile
        settings: {
          slidesToShow: 1,
          arrows: false,
          centerMode: false
        }
      }
    ]
  };



  return (
    <>
      <Navbar />
      <div className="container-fluid web-container" >
        <div className="wrapper">
          <section className='section-margin'>
            <center>
              <div className='heading-for-all' data-aos="fade-up">
                <h2>Digital Marketing</h2>
              </div>
            </center>
          </section>

          <Slider {...settings} className="news-slider">
            {items.map((item, index) => (
              <div className="news-slider__item" key={index} data-aos="fade-up"
                data-aos-delay="1000">
                <div className="news__item news__item3" >
                  <div className="news__title">{item.title}</div>
                  <ul className="news__txt">
                    {item.description.map((point, idx) => (
                      <li key={idx}>{point}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </Slider>

        </div>

        <div className="container d-flex justify-content-center my-4"
          data-aos="fade-up"
          data-aos-delay="1000">
          <button className="button-alll" onClick={handleShow}>
            Get Enquiry
          </button>
        </div>
      </div>

      <Formpage show={show} onClose={handleClose} />
    </>
  );
}

export default Digital;

